// extracted by mini-css-extract-plugin
export default {"file":"file_file__T1GYM","icon":"file_icon__LhcI8","label":"file_label__qJ2Kq","list":"file_list__UgPJW"};